// extracted by mini-css-extract-plugin
export var header = "GenericPage-module--header--a41f6";
export var root = "GenericPage-module--root--18022";